import angular from 'angular';

import PlanPriceModule from './plan-price';
import PlanSubscriptionModule from './plan-subscription';

export default angular
    .module('common.component.plans.component.plan.component', [
        PlanPriceModule.name,
        PlanSubscriptionModule.name
    ]);



// WEBPACK FOOTER //
// ./src/common/component/plans/component/plan/component/index.js